import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as SVGLogoAlyPlus } from "assets/img/aly_plus_dark_logo.svg";
import { ReactComponent as SVGLogoAlyPlusLight } from "assets/img/aly_plus_light_logo.svg";
import { ReactComponent as SVGBcertoDark } from "assets/img/b_certo_dark_logo.svg";
import { ReactComponent as SVGBcertoLight } from "assets/img/b_certo_light_logo.svg";
import { isBcerto } from "utils";

const Logo = (props) => {
    const { height, width, justify } = props;
    const logoHeight = isBcerto ? height * 1.3 : height;
    const logoWidth = width ? width * 1.3 : width;
    const isAuthRoute = window.location.pathname.includes("/auth");

    const renderLogo = () => {
        if (isBcerto) {
            return isAuthRoute
                ? <SVGBcertoLight height={logoHeight} width={logoWidth} className="logo-login" />
                : <SVGBcertoDark height={logoHeight} width={logoWidth} className="logo-login" />;
        }

        return isAuthRoute
            ? <SVGLogoAlyPlusLight height={height} width={width} className="logo-login" />
            : <SVGLogoAlyPlus height={height} width={width} className="logo-login" />;
    };

    return (
        <div style={{ display: "flex", justifyContent: justify }}>
            {renderLogo()}
        </div>
    );
};

Logo.defaultProps = {
    height: 55,
    justify: "center"
};

Logo.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
    justify: PropTypes.string
};

export { Logo };
